import S from './core.js';

/* The heavy libraries are loaded only when someone actually exports. */
export async function makeExcel(layout) {
  const mod = await import('exceljs/dist/exceljs.min.js');
  return S.buildWorkbook(mod.default ?? mod, layout);
}
export async function makePdf(layout) {
  const { jsPDF } = await import('jspdf');
  const { applyPlugin } = await import('jspdf-autotable');
  applyPlugin(jsPDF);
  return S.buildPdf(jsPDF, layout);
}
/* The Summary as an Excel file: one column per report plus an "All reports" column. */
export async function makeSummaryExcel(summary) {
  const mod = await import('exceljs/dist/exceljs.min.js');
  const ExcelJS = mod.default ?? mod;
  const wb = new ExcelJS.Workbook();
  wb.creator = 'Settlement Report Studio';
  const ws = wb.addWorksheet(`${summary.month} ${summary.year}`.slice(0, 31));
  const n = summary.columns.length;
  const bold = { bold: true };
  const fill = (argb) => ({ type: 'pattern', pattern: 'solid', fgColor: { argb } });
  ws.columns = [{ width: 46 }, ...summary.columns.map(() => ({ width: 22 })), { width: 22 }];
  ws.addRow([summary.title]).font = { bold: true, size: 14 };
  ws.addRow([]);
  const head = ws.addRow(['', ...summary.columns.map((c) => c.id), 'All reports']);
  ws.addRow(['Client', ...summary.columns.map((c) => c.client), '']);
  ws.addRow(['Account manager', ...summary.columns.map((c) => c.manager), '']);
  const when = (row) => (row ? `${row.approved_by_name}, ${new Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(row.approved_at)).replace(',', '')}` : 'Pending');
  ws.addRow(['Finance approval', ...summary.columns.map((c) => when(c.finance)), '']);
  ws.addRow(['AM approval', ...summary.columns.map((c) => when(c.account_manager)), '']);
  [head, ...[4, 5, 6, 7].map((r) => ws.getRow(r))].forEach((r) => { r.font = bold; });
  head.eachCell((c) => { c.fill = fill('FFE1E1E1'); c.alignment = { horizontal: 'center' }; });
  ws.addRow([]);
  summary.sections.forEach((sec) => {
    const t = ws.addRow([sec.title]);
    for (let c = 1; c <= n + 2; c++) { t.getCell(c).fill = fill('FF191919'); t.getCell(c).font = { bold: true, color: { argb: 'FFFFFFFF' } }; }
    sec.rows.forEach((r) => {
      const row = ws.addRow([r.label, ...r.values, r.total]);
      const numFmt = r.kind === 'int' ? '#,##0' : r.kind === 'pct' ? '0.0"%"' : '#,##0.00';
      for (let c = 2; c <= n + 2; c++) { row.getCell(c).numFmt = numFmt; row.getCell(c).alignment = { horizontal: 'right' }; }
      row.getCell(n + 2).font = bold;
    });
  });
  ws.views = [{ state: 'frozen', xSplit: 1, ySplit: 3 }];
  ws.pageSetup = { orientation: 'landscape', paperSize: 9, fitToPage: true, fitToWidth: 1, fitToHeight: 0 };
  return wb.xlsx.writeBuffer();
}
export async function makeZip(files) {               // files: [{ name, data }]
  const JSZip = (await import('jszip')).default;
  const zip = new JSZip();
  files.forEach((f) => zip.file(f.name, f.data));
  return zip.generateAsync({ type: 'uint8array' });
}
export function saveFile(name, data, type) {
  const url = URL.createObjectURL(new Blob([data], { type }));
  const a = Object.assign(document.createElement('a'), { href: url, download: name });
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export const fileBase = (r) => `${r.settlement_report_id}_${r.report_year}_${r.as_at_date}`.replace(/[^A-Za-z0-9_.-]+/g, '_');
